<template>
  <div style="width: 100%;height: 500px">
    <Tabs value="upload_map">

      <TabPane label="地图添加" name="upload_map">
        <Row>
          <Form ref="searchFormRef" :label-width="100" :model="searchForm" inline @submit.native.prevent>
            <FormItem label="地址" prop="address">
              <Input v-model="searchForm.address" placeholder="" style="width: 450px" @keyup.enter.native="searchAddres"></Input>
            </FormItem>
            <FormItem>
              <Button type="primary" @click="searchAddres">确定</Button>
            </FormItem>
          </Form>
        </Row>
        <Row style="height: 100%">
          <Col span="12">
            <div id="mapContainer" style="width:100%;height: 100%"></div>
          </Col>
          <Col span="12">
            <Form ref="editForm" :label-width="100" :model="formData">
              <FormItem label="站点名称" prop="gas_name">
                <Input v-model="formData.gas_name" placeholder=""></Input>
              </FormItem>
              <Row>
                <Col span="8">
                  <FormItem label="站点类型" prop="station_type">
                    <Select v-model="formData.station_type" placeholder="站点类型">
                      <Option value="">全部站点</Option>
                      <Option v-for="(item,key) in station_types" :key="key" :value="item.id">{{item.name}}</Option>
                    </Select>
                  </FormItem>
                </Col>
                <Col span="8">
                  <FormItem label="油站类型" prop="oil_station_type">
                    <Select v-model="formData.oil_station_type" placeholder="油站类型">
                      <Option value="2">油车</Option>
                      <Option value="3">撬装</Option>
                      <Option value="4">加油站</Option>
                    </Select>
                  </FormItem>
                </Col>
                <Col span="8">
                  <FormItem label="渠道" prop="platform">
                    <Select v-model="formData.platform" placeholder="渠道">
                      <Option v-for="(item,key) in platform" :key="key" :value="item.id">{{item.name}}</Option>
                    </Select>
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col span="8">
                  <FormItem label="对外价格" prop="price">
                    <Input type="number" v-model="formData.price" placeholder=""></Input>
                  </FormItem>
                </Col>
                <Col span="8">
                  <FormItem label="对内价格" prop="price2">
                    <Input type="number" v-model="formData.price2" placeholder=""></Input>
                  </FormItem>
                </Col>
                    <Col span="8">
                  <FormItem label="不带票价格" prop="price2">
                    <Input type="number" v-model="formData.no_bill_price" placeholder=""></Input>
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col span="12">
                  <FormItem label="合伙人电话" prop="agent_user_mobile">
                    <Input v-model="formData.agent_user_mobile" placeholder=""></Input>
                  </FormItem>
                </Col>
                <Col span="12">
                  <FormItem label="站点用户电话" prop="user_mobile">
                    <Input v-model="formData.user_mobile" placeholder=""></Input>
                  </FormItem>
                </Col>
              </Row>

              <FormItem label="省市区">
                <span>{{formData.province_name}}{{formData.city_name}}{{formData.county_name}}</span>
              </FormItem>
              <FormItem label="地址">
                <span>{{formData.gas_address}}</span>
              </FormItem>
              <FormItem label="经纬度">
                <span>{{formData.longitude}},{{formData.latitude}}</span>
              </FormItem>

              <Row>
                <Col span="8">
                  <FormItem label="联系人" prop="contact_user">
                    <Input v-model="formData.contact_user" placeholder=""></Input>
                  </FormItem>
                </Col>
                <Col span="8">
                  <FormItem label="联系电话1" prop="contact_mobile">
                    <Input v-model="formData.contact_mobile" placeholder=""></Input>
                  </FormItem>
                </Col>
                <Col span="8">
                  <FormItem label="联系电话2" prop="contact_mobile2">
                    <Input v-model="formData.contact_mobile2" placeholder=""></Input>
                  </FormItem>
                </Col>
              </Row>
              <Row>
                <Col span="24">
                  <FormItem label="油品" prop="oil_products">
                    <Select v-model="formData.oil_products" multiple clearable placeholder="请选择油品">
                      <Option v-for="item in oilProducts" :key="item.id" :value="item.id">{{item.label}}</Option>
                    </Select>
                  </FormItem>
                </Col>
              </Row>
              <!-- 该站点包含的油品 -->
               
              <FormItem>
                <Button type="primary" @click="addStationByMap">确定</Button>
              </FormItem>
            </Form>
          </Col>
        </Row>



      </TabPane>

      <TabPane label="表格添加" name="upload_excel">
        <Form ref="uploadForm" :label-width="100" :model="uploadFormData" inline>
          <FormItem label="站点类型" prop="station_type">
            <Select v-model="uploadFormData.station_type" placeholder="站点类型">
              <Option value="">全部站点</Option>
              <Option v-for="(item,key) in station_types" :key="key" :value="item.id">{{item.name}}</Option>
            </Select>
          </FormItem>
          <!--<FormItem label="油站类型" prop="station_type">
            <Select v-model="uploadFormData.oil_station_type" placeholder="油站类型">
              <Option value="2">油车</Option>
              <Option value="3">撬装</Option>
              <Option value="4">加油站</Option>
            </Select>
          </FormItem>
          <FormItem label="合伙人电话" prop="agent_user_mobile">
            <Input v-model="uploadFormData.agent_user_mobile" placeholder=""></Input>
          </FormItem>
          <FormItem label="站点用户电话" prop="user_mobile">
            <Input v-model="uploadFormData.user_mobile" placeholder=""></Input>
          </FormItem>-->
          <FormItem  :label-width="0">
            <Button type="info" @click="downAllStation">下载站点</Button>
          </FormItem>

          <FormItem :label-width="0">
            <Button type="primary" @click="downDemo">下载模板</Button>
          </FormItem>
          <FormItem :label-width="0">
            <Upload :action="apiPath + '/admin/gas/addFileTask'"
                    :on-success="uploadSuccess"
                    :on-error="uploadError"
                    :on-remove="handleRemove"
                    :before-upload="beforeUpload"
                    :format="['xlsx']"
                    :max-size="5120"
                    :on-format-error="formatError"
                    :on-exceeded-size="exceededSize"
                    :show-upload-list=false
                    :data="uploadFormData"
                    :headers="uploadHeader"
            >
              <Button icon="ios-cloud-upload-outline" type="primary">上传Excel</Button>
            </Upload>
          </FormItem>
         <!-- <FormItem  :label-width="0">
            <Button type="primary" @click="uploadSubmit">确认提交</Button>
          </FormItem>-->

        </Form>


        <pageTable ref="table"
                   :tableTitle="tableTitle"
                   :searchData="searchForm"
                   :showSearchForm="false"
                   tableApi="admin/gas/getTaskLists"
        >
        </pageTable>

      </TabPane>
    </Tabs>

  </div>
</template>

<script>
  window._AMapSecurityConfig = {
    securityJsCode: "20341665b1257613258851e2f4d03f9b"
  };

  import AMapLoader from '@amap/amap-jsapi-loader';
  import config from '@/config/base-config';
  import pageTable from "@/components/table/pageTable";

  export default {
    name: "mapStation",
    components:{pageTable},
    data() {
      return {
        formData:{
          gas_name:'',
          station_type:'',
          oil_station_type:'',
          price:'',
          price2:'',
          province_name:'',
          city_name:'',
          county_name:'',
          gas_address:'',
          longitude:'',
          latitude:'',
          contact_user:'',
          contact_mobile:'',
          contact_mobile2:'',
          agent_user_mobile:'',
          user_mobile:'',
          platform:'',
          no_bill_price:'',
          oil_products: []
        },
        uploadFormData:{
          station_type:'',
          oil_station_type:'',
          agent_user_mobile:'',
          user_mobile:'',
        },
        searchForm:{
          address:''
        },
        station_types:[],
        platform:[],
        apiPath:config.API_PATH,
        tableTitle:[
          {title:'任务编号',key:'task_id',align:'center'},
          {title:'数量',key:'total_num',align:'center'},
          {title:'成功数量',key:'success_num',align:'center'},
          {title:'状态',key:'status_name',align:'center'},
          {title:'创建时间',key:'create_time',align:'center'},
          {title:'操作',key:'city_name',align:'center',render:(h,params)=>{
              let has_error = params.row.has_error;
              let content=[];
              content.push(h('Button',{
                props: {type: 'error', size: 'small',},
                style: {marginLeft: '5px'},
                on: {click: () => {this.deleteTask(params.row.task_id)}
                }
              },'删除任务'))
              content.push(h('Button',{
                props: {type: 'primary', size: 'small',},
                style: {marginLeft: '5px'},
                on: {click: () => {this.$commonFun.downFileByPost('admin/gas/downTaskFile',{task_id:params.row.task_id})}
                }
              },'原文件'))
              if (has_error){
                content.push(h('Button',{
                  props: {type: 'primary', size: 'small',},
                  style: {marginLeft: '5px'},
                  on: {click: () => {this.$commonFun.downFileByPost('admin/gas/downErrorFile',{task_id:params.row.task_id})}
                  }
                },'处理失败文件'))
              }

              return h('div',content)
            }},
        ],
        tableData:[],
        uploadHeader:{token:sessionStorage.getItem('token')},
        // 可选油品列表：对应 1:0#柴油 2:-10#柴油 3:-20#柴油 4:-35#柴油 5:-50#柴油
        oilProducts: [
          { id: "0#", label: '0#柴油' },
          { id: "-10#", label: '-10#柴油' },
          { id: "-20#", label: '-20#柴油' },
          { id: "-35#", label: '-35#柴油' },
          { id: "-50#", label: '-50#柴油' },
        ]
      }
    },
    methods: {
      async initMap(){
        AMapLoader.load({
          key:"c3219f1ed0f4493a4f3ca6ead5e51d37",     // 申请好的Web端开发者Key，首次调用 load 时必填
          version:"2.0",      // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
          plugins:['AMap.LabelsLayer','AMap.LabelMarker','AMap.Geocoder','AMap.Marker'],       // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        }).then((AMap)=>{
          this.map = new AMap.Map("mapContainer",{  //设置地图容器id
            // viewMode:"3D",    //是否为3D地图模式
            zoom:15,           //初始化地图级别
            center:[104.07,30.57], //初始化地图中心点位置
          });
          this.AMap = AMap;
          this.geocoder = new AMap.Geocoder();
          this.marker = new AMap.Marker();
          this.map.on('click', (ev)=> {
            console.log(ev)

            // 触发事件的地理坐标，AMap.LngLat 类型
            let lnglat = ev.lnglat;
            this.marker.setPosition(lnglat);//设置标记的位置
            this.map.add(this.marker);

            this.geocoder.getAddress(lnglat, (status, result)=> {
              console.log(result)
              if (status === 'complete' && result.regeocode) {
                let address = result.regeocode.formattedAddress,
                  province_name = result.regeocode.addressComponent.province,
                  city_name = result.regeocode.addressComponent.city,
                  district_name = result.regeocode.addressComponent.district;
                this.formData.province_name = province_name;
                this.formData.city_name = city_name;
                this.formData.county_name = district_name;
                this.formData.gas_address = address;
                this.formData.latitude = lnglat.lat;
                this.formData.longitude = lnglat.lng;
                //$('#longitude').val(lnglat.lng);//经纬度
                //$('#latitude').val(lnglat.lat);
              }else{
                this.$commonFun.errorTip('获取地址失败')
              }
            });

          });
        }).catch(e=>{
          console.log(e);
        })
      },
      openInfoWindow(item){
        let content = [
          '<div>',
          `<b>${item.gas_name}</b><br/>`,
          `<span>${item.gas_address}</span><br/>`,
          '</div>'
      ];
      // 创建 infoWindow 实例
        let infoWindow = new this.AMap.InfoWindow({
          anchor: 'top',
          offset:[15,-10],
          content: content.join("")  //传入 dom 对象，或者 html 字符串
        });
        // 打开信息窗体
        infoWindow.open(this.map,[item.longitude, item.latitude]);
      },
      async initPage(){
        let data = await this.$commonFun.postProxy('admin/common/getPageInitInfo',{type:['stationType','platform']})
        this.station_types = data.data.stationType
        this.platform = data.data.platform
      },
      uploadSuccess(res){
        this.$commonFun.dealApiResult(res,()=>{

        })
        // this.tableData = res.data
      },
      handleRemove (file) {
        const fileList = this.$refs.upload.fileList;
        this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
        this.proofs.splice(fileList.indexOf(file), 1)
      },
      uploadError(){
        this.$commonFun.errorTip('上传失败请重试')
      },
      formatError(){
        this.$commonFun.errorTip('文件格式不正确')
      },
      exceededSize(){
        this.$commonFun.errorTip('文件大小不能超过2M')
      },
      beforeUpload(){
      },
      async uploadSubmit(){
        let params = this.uploadFormData;
        params['data']=JSON.stringify(this.tableData);
        let res = await this.$commonFun.postProxy('admin/gas/addStationByExcel',params)
        this.$commonFun.dealApiResult(res,()=>{
          this.$commonFun.successTip('导入站点成功',()=>{
            this.uploadFormData = [];
          })
        })
      },
      async addStationByMap(){
        let res = await this.$commonFun.postProxy('admin/gas/addStationByMap',this.formData)
        this.$commonFun.dealApiResult(res,()=>{
          this.$commonFun.successTip('添加成功',()=>{
            this.$refs.editForm.resetFields();
          })
        })
      },
      downDemo(){
        window.open(config.API_PATH+'static/站点导入模板.xlsx?v=003');
      },
      searchAddres(){
        let address = this.searchForm.address;
        if (address === '') return false;
        this.geocoder.getLocation(address, (status, result)=> {
          console.log(result)
          if (status === 'complete' && result.info === 'OK') {
            // result中对应详细地理坐标信息
            let data = result.geocodes[0];
            let lnglat = [data.location.lng,data.location.lat];
            console.log(lnglat)
            this.map.setCenter(lnglat);
            this.marker.setPosition(lnglat);  //设置标记的位置
            this.map.add(this.marker)

            this.formData.province_name = data.addressComponent.province;
            this.formData.city_name = data.addressComponent.province;
            this.formData.county_name = data.addressComponent.province;
            this.formData.gas_address = data.formattedAddress;
            this.formData.latitude = data.location.lat;
            this.formData.longitude = data.location.lng;
          }
        })
      },
      downAllStation(){
        this.$commonFun.downFileByPost('admin/gas/downAllStation',this.uploadFormData)
      },
      async deleteTask(task_id){
        let res = await this.$commonFun.postProxy('admin/gas/deleteTaskFile',{task_id});
        this.$commonFun.dealApiResult(res,()=>{
          this.$commonFun.successTip(res.msg,()=>{
            this.$refs.table.getLists();
          })
        })
      },

    },
    mounted() {
      this.initPage();
      this.initMap();
    },
  }
</script>

<style scoped>

</style>
